{
  "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
  "questions": [
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-001",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welk leesteken hoort op de plek van het streepje? 'De zon schijnt _ het is warm buiten.'",
      "options": ["een komma (,)", "een punt (.)", "een uitroepteken (!)", "een dubbele punt (:)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming of verbinding", "content": "Een komma gebruik je om twee zinsdelen te verbinden die bij elkaar horen. Hier horen 'de zon schijnt' en 'het is lekker warm' bij elkaar.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_verbinding",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De twee zinsdelen horen bij elkaar: 'De zon schijnt' en 'het is lekker warm buiten.' Een komma verbindt ze. Een punt zou twee losse zinnen maken — dat kan ook, maar een komma past hier beter omdat de zinnen over hetzelfde gaan.",
        "solutionSteps": ["Twee zinsdelen die bij elkaar horen", "Verbind met een komma"],
        "distractorExplanations": {
          "0": "Goed! Een komma verbindt de twee zinsdelen die bij elkaar horen.",
          "1": "Je dacht waarschijnlijk dat er een punt moest. Maar dan krijg je twee losse zinnen. Hier horen de zinsdelen bij elkaar — een komma past beter. Onthoud: een komma verbindt, een punt scheidt.",
          "2": "Een uitroepteken gebruik je bij verbazing of een bevel. Deze zin is gewoon een mededeling. Onthoud: uitroepteken = emotie of bevel.",
          "3": "Een dubbele punt gebruik je voor een opsomming of uitleg. Hier worden twee zinsdelen verbonden. Onthoud: dubbele punt = 'namelijk' of opsomming."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-punt-ipv-komma", "label": "Kiest punt waar komma past", "optionIndex": 1 },
          { "id": "spr.leesteken-uitroep-verkeerd", "label": "Kiest uitroepteken bij mededeling", "optionIndex": 2 },
          { "id": "spr.leesteken-dubbele-punt-verkeerd", "label": "Kiest dubbele punt waar komma past", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-002",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welke zin heeft de komma op de juiste plek?",
      "options": [
        "Ik heb brood kaas, en melk gekocht.",
        "Ik heb, brood kaas en melk gekocht.",
        "Ik heb brood, kaas en melk gekocht.",
        "Ik heb brood kaas en, melk gekocht."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'. Dus: brood, kaas en melk.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_opsomming",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij een opsomming zet je een komma tussen elk woord, behalve voor het laatste woord met 'en': brood, kaas en melk.",
        "solutionSteps": ["Herken de opsomming: brood, kaas, melk", "Komma tussen de woorden", "Geen komma voor 'en'", "brood, kaas en melk"],
        "distractorExplanations": {
          "0": "De komma staat op de verkeerde plek. Bij een opsomming zet je de komma na elk woord behalve het laatste. Onthoud: brood, kaas en melk.",
          "1": "De komma staat na 'heb', maar dat hoort niet. De komma hoort tussen de woorden in de opsomming. Onthoud: komma = tussen de opgesomde woorden.",
          "2": "Goed! Komma na 'brood', geen komma voor 'en'.",
          "3": "De komma staat voor 'melk', maar die hoort na 'brood'. Bij een opsomming: komma na elk woord behalve het laatste."
        }
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-003",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Hoeveel punten horen er in deze tekst? 'Ik ga naar school Daarna ga ik voetballen Het wordt leuk'",
      "options": ["1 punt", "3 punten", "2 punten", "0 punten"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Punt aan het einde van een zin", "content": "Elke zin eindigt met een punt. Tel de zinnen: 'Ik ga naar school.' 'Daarna ga ik voetballen.' 'Het wordt leuk.' = 3 zinnen = 3 punten.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_punt_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Er zijn 3 zinnen in deze tekst: 'Ik ga naar school.' + 'Daarna ga ik voetballen.' + 'Het wordt leuk.' Elke zin eindigt met een punt, dus er horen 3 punten in de tekst. Onthoud: tel het aantal zinnen — elke zin krijgt een punt aan het einde.",
        "solutionSteps": ["Tel de zinnen: 3 zinnen", "Elke zin eindigt met een punt", "3 zinnen = 3 punten"],
        "distractorExplanations": {
          "0": "Je telde maar 1 punt. Maar er zijn 3 zinnen, en elke zin eindigt met een punt. Onthoud: tel de zinnen — dat is het aantal punten.",
          "1": "Goed! 3 zinnen = 3 punten. Elke zin eindigt met een punt.",
          "2": "Je telde 2 punten, maar vergat de punt na de laatste zin. Ook 'Het wordt leuk' eindigt met een punt. Onthoud: elke zin krijgt een punt, ook de laatste.",
          "3": "Elke zin moet eindigen met een leesteken. Zonder punten wordt de tekst één lange, onleesbare zin. Onthoud: elke zin = een punt."
        }
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-004",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Wanneer gebruik je GEEN komma?",
      "options": [
        "Bij een opsomming van woorden",
        "Voor het woord 'maar'",
        "Na een bijzin aan het begin van een zin",
        "Tussen onderwerp en persoonsvorm"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Geen komma tussen onderwerp en PV", "content": "Tussen het onderwerp en de persoonsvorm komt NOOIT een komma. Fout: 'De hond, blaft.' Goed: 'De hond blaft.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_geen_komma",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Tussen het onderwerp en de persoonsvorm komt nooit een komma. 'De hond blaft' — geen komma tussen 'hond' en 'blaft'. Bij opsommingen, voor 'maar', en na een bijzin aan het begin wél een komma.",
        "solutionSteps": ["Onderwerp + persoonsvorm = NOOIT een komma", "Opsomming, 'maar', bijzin = WEL een komma"],
        "distractorExplanations": {
          "0": "Bij een opsomming gebruik je juist WEL een komma: appels, peren en bananen. Onthoud: opsomming = komma.",
          "1": "Voor 'maar' gebruik je juist WEL een komma: 'Het regent, maar ik ga toch.' Onthoud: voor 'maar' altijd een komma.",
          "2": "Na een bijzin aan het begin gebruik je juist WEL een komma: 'Als het regent, blijf ik binnen.' Onthoud: bijzin vooraan = komma erna.",
          "3": "Goed! Tussen onderwerp en persoonsvorm komt nooit een komma."
        }
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-005",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "fill_in",
      "question": "Zet het juiste leesteken op de plek van het streepje: 'Ik heb een hond _ een kat en een vis.' Typ alleen het leesteken.",
      "correctAnswer": ",",
      "data": {
        "acceptedAnswers": [","],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'. Dus: hond, kat en vis.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Dit is een opsomming: hond, kat en vis. Na 'hond' komt een komma, want bij een opsomming zet je een komma tussen de woorden. Voor 'en' komt geen komma. Onthoud de regel: komma tussen elk woord in de opsomming, behalve voor 'en'.",
        "solutionSteps": ["Herken de opsomming: hond, kat en vis", "Komma na 'hond'", "Geen komma voor 'en'"]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-006",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "error_spotting",
      "question": "Zoek de leestekenfout in deze tekst en verbeter hem.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Ik heb appels peren en bananen gekocht. Daarna ging ik naar huis.",
        "errors": [
          {
            "word": "appels peren",
            "position": 2,
            "correction": "appels, peren",
            "explanation": "Bij een opsomming zet je een komma tussen de woorden: appels, peren en bananen."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'.\nFout: appels peren en bananen\nGoed: appels, peren en bananen", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er ontbreekt een komma in de opsomming. Het moet zijn: 'appels, peren en bananen'. Bij een opsomming zet je een komma tussen elk woord, behalve voor 'en'. De tweede zin is correct — de punt staat goed.",
        "solutionSteps": [
          "Herken de opsomming: appels, peren, bananen",
          "Komma na 'appels': appels, peren en bananen",
          "Geen komma voor 'en' (dat is de regel)",
          "De punt na de eerste zin is correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-007",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke bewering over leestekens klopt.",
      "data": {
        "statements": [
          { "text": "Bij een opsomming zet je een komma tussen de woorden.", "isTrue": true },
          { "text": "Voor het woord 'en' in een opsomming komt een komma.", "isTrue": false },
          { "text": "Elke zin eindigt met een punt.", "isTrue": true },
          { "text": "Tussen onderwerp en werkwoord komt een komma.", "isTrue": false },
          { "text": "Na een bijzin aan het begin komt een komma.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommaregels", "content": "Komma bij: opsomming (appels, peren en bananen), voor 'maar', na bijzin vooraan. Geen komma: voor 'en' in opsomming, tussen onderwerp en werkwoord.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_tf_series",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Opsomming → komma ✓. Voor 'en' → GEEN komma ✗. Zin eindigt met punt ✓. Onderwerp + werkwoord → GEEN komma ✗. Bijzin vooraan → komma erna ✓. Regel: de komma verbindt of scheidt zinsdelen, maar nooit tussen onderwerp en werkwoord.",
        "solutionSteps": [
          "Opsomming: appels, peren en bananen → komma ✓",
          "Voor 'en': geen komma (het laatste woord) ✗",
          "Einde zin: altijd een punt ✓",
          "Onderwerp + werkwoord: nooit een komma ✗",
          "Bijzin vooraan: 'Als het regent, blijf ik binnen.' → komma ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-008",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "matching",
      "question": "Koppel elke situatie aan het juiste leesteken.",
      "data": {
        "pairs": [
          { "left": "Einde van een zin", "right": "Punt (.)" },
          { "left": "Tussen woorden in een opsomming", "right": "Komma (,)" },
          { "left": "Bij verbazing of een bevel", "right": "Uitroepteken (!)" },
          { "left": "Bij een vraag", "right": "Vraagteken (?)" }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Leestekens kiezen", "content": "Punt: einde van een gewone zin. Komma: opsomming of verbinding. Uitroepteken: verbazing of bevel. Vraagteken: bij een vraag.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Einde zin → punt. Opsomming → komma. Verbazing/bevel → uitroepteken. Vraag → vraagteken. Elk leesteken heeft een eigen functie.",
        "solutionSteps": [
          "Punt → einde van een gewone zin",
          "Komma → tussen woorden in een opsomming",
          "Uitroepteken → verbazing of bevel",
          "Vraagteken → bij een vraag"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-009",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: zijn de leestekens correct?",
      "data": {
        "sentences": [
          { "text": "Ik heb appels, peren en bananen gekocht.", "hasError": false },
          { "text": "De hond, blaft hard.", "hasError": true, "correction": "De hond blaft hard.", "explanation": "Tussen het onderwerp (de hond) en de persoonsvorm (blaft) komt nooit een komma." },
          { "text": "Het regent, maar ik ga toch.", "hasError": false },
          { "text": "We gaan naar school. Het is maandag.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommaregels controleren", "content": "Geen komma tussen onderwerp en persoonsvorm. Wel komma bij opsomming en voor 'maar'. Elke zin eindigt met een punt.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_error_judge",
      "variantIndex": 9,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De fout zit in zin 2: 'De hond, blaft hard.' Tussen het onderwerp (de hond) en de persoonsvorm (blaft) komt nooit een komma. Het moet zijn: 'De hond blaft hard.' De andere zinnen zijn correct: opsomming met komma ✓, komma voor 'maar' ✓, punt aan het einde ✓.",
        "solutionSteps": [
          "Zin 1: opsomming met komma → correct ✓",
          "Zin 2: komma tussen onderwerp en werkwoord → fout ✗",
          "Zin 3: komma voor 'maar' → correct ✓",
          "Zin 4: twee zinnen met punt → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}